import Admin from "../Admin";
import CardAdminOrderStatusReasonDetailList from "../../../Component/Card/Admin/OrderStatusReasonDetail/CardAdminOrderStatusReasonDetailList";
import PageHeader from "../../../Component/PageHeader";
import MUIButton from "@mui/material/Button";
import MUIAddIcon from "@mui/icons-material/Add";

export default class AdminOrderStatusReasonDetailList extends Admin {

    /**
     * Render the content.
     */
    renderContent() {
        return (
            <CardAdminOrderStatusReasonDetailList />
        );
    }

    renderHeader() {
        const handleClickCreate = () => {
            this.props.history.push({
                pathname: "/admin/orderStatusReasonDetail"
            });
        };

        const buttons = [
            (<MUIButton
                component="label"
                variant="contained"
                startIcon={<MUIAddIcon />}
                onClick={handleClickCreate}>Create New</MUIButton>),
        ];

        return (
            <PageHeader title="Order Status Reason Details" buttons={buttons} />
        );
    }
}
